import { PipeTransform } from '@angular/core';
import * as changeCase from 'change-case';
import { isString } from 'lodash';
var ChangeCasePipe = /** @class */ (function () {
    function ChangeCasePipe() {
    }
    ChangeCasePipe.prototype.transform = function (value, option) {
        if (!isString(value)) {
            return null;
        }
        return changeCase[option](value);
    };
    return ChangeCasePipe;
}());
export { ChangeCasePipe };
